module.exports = __webpack_public_path__ + "images/admin/bg-noise3.png";